import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ShowFileOnDiskMutationVariables = Types.Exact<{
  input: Types.ShowFileOnDiskInput;
}>;


export type ShowFileOnDiskMutation = { __typename?: 'Mutation', showFileOnDisk?: boolean | null };


export const ShowFileOnDisk = /*#__PURE__*/ gql`
    mutation ShowFileOnDisk($input: ShowFileOnDiskInput!) {
  showFileOnDisk(input: $input)
}
    ` as unknown as DocumentNode<ShowFileOnDiskMutation, ShowFileOnDiskMutationVariables>;

          

          export const useShowFileOnDiskMutation = (options?:MutationHookOptions<ShowFileOnDiskMutation, ShowFileOnDiskMutationVariables>) => useMutation(ShowFileOnDisk, options);
          

          export type ShowFileOnDiskMutationOptions = MutationHookOptions<ShowFileOnDiskMutation, ShowFileOnDiskMutationVariables>;

          

          export type ShowFileOnDiskMutationResult = ReturnType<typeof useShowFileOnDiskMutation>[1];

          
